
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import {Getter} from "vuex-class";
import MylobyAutocompleteMultiple from "@/components/generic/autocomplete-multiple.vue";

@Component({
  components: {
    MylobyAutocompleteMultiple,
  },
})
export default class AddKeysModal extends Vue {
    @Prop({ default: null})
    public groupId: number;

    @Prop({ default: false })
    public displayModal: boolean;

    @Prop({ default: false })
    public isManager: boolean;

    @Prop({ default: null})
    public buildingId: number;

    private updateInProgress: boolean = false;
    private selectedKeys: any[] = [];

    @Getter private currentUser: any;
    @Getter private isMobile: boolean;

    private mounted(): void {
      //
    }

    private fetchKeys({search, page, itemsPerPage}: { search: string, page: number, itemsPerPage: number },
    ): Promise<{ count: number; rows: any[] }> {
      return this.$store.dispatch("users/getMyKeys", {
        id: this.currentUser.id,
        query: {
          role: this.isManager ? "MANAGER" : "GUEST",
          search,
          page,
          itemsPerPage,
          buildingId: this.buildingId,
        },
      }).then((data) => ({ count: data.count, rows: data.keys }));
    }

    private async addKeys(): Promise<void> {
        this.updateInProgress = true;
        await this.$store.dispatch("keyGroups/addKeys", {
            id: this.groupId,
            keyIds: this.selectedKeys.map(({id}) => id),
        }).then(() => {
            this.$store.commit("alerts/displaySuccess", {
              msg: this.$i18n.t("keyGroup.addKeys.successMessage"),
            });
            this.closeEdit();
            this.$emit("reset");
        }).catch((error) => {
            this.$store.commit("alerts/displayHttpError", { error });
        }).finally(() => {
            this.updateInProgress = false;
        });
    }

    private closeEdit(): void {
        this.selectedKeys = [];
        this.$emit("close");
    }
}
